module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAAAXNSR0IArs4c6QAAAQdJREFUOE+Nkr1KA0EUhc8ZIYXYCxrIiq34CMGfLm9gI9hpurUVYrSPlmqTlDZJkToIupVPYCUk2FkJWogic2RX1OzNxHWK4c4M38e9hyEAVOLrAclyWn8vAV7CkaOWPV3/oVW9G39Pa6ZbtH8j+5CeBXwIrDv4mqc7sII8LD2CvIS0BXK+SGBg7o1Oq+dRnOyCOhsbIdhBDhZwBaAB4JjApslgQvDnzDYHm0EGV+KkTWonFNrkHd/lEXHGX2QwmnLRc9IBsF0kENggtOjlul/wPwVeOnTkAqnesLU2+IULBBb8+SS5VgMjhMAwbDqYBk6HM0HTLT1trLy9zt6X5l5WRyfrtzbMT97UmyYcxF3wAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/image1/biaoqian2.png
// module id = 0XPM
// module chunks = 34